import React from 'react'
import CustomAppBar from '../components/CustomAppBar'
import { Box, Typography } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom';
import PrimaryButton from '../components/PrimaryButton';
import AppContainer from '../components/AppContainer';
import TextContainer from '../components/TextContainer';
import { useSelector } from 'react-redux';

function Done() {
    const navigate = useNavigate();

    // get the 'done' title and subtitle from the store
    const title = useSelector((state) => state.done.title);
    const subtitle = useSelector((state) => state.done.subtitle);

    console.log("title", title, "subtitle", subtitle);

    return (
        <AppContainer>
            <Box style={{ display: 'flex', flexDirection: 'column', minHeight: window.innerHeight }}>
                <CustomAppBar />
                {/* Box to fill space, pushing button to bottom of screen */}
                <Box style={{ flex: 1 }}>
                    <TextContainer>
                        <Typography variant='h5' sx={{marginTop: '40px', textAlign: 'center'}}>{title}</Typography>
                        <Typography variant='body2' sx={{marginTop: '15px', fontStyle: 'italic', fontSize: '12px', textAlign: 'center'}}>{subtitle}</Typography>
                    </TextContainer>
                </Box>
                {/* Button at the bottom of the screen */}
                <TextContainer customStyles={{marginBottom: '40px'}}>
                    <PrimaryButton text={"Done"} customStyles={{width: '100%'}} onClick={() => {navigate(`/home`)}}/>
                </TextContainer>
            </Box>
        </AppContainer>
    )
}

export default Done